import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '@core/auth.service';
import { FooterLayoutComponent } from '@modules/profile/component/marketing-page-layout-container/footer-layout/footer-layout.component';
import type { FooterLayoutData } from '@modules/profile/component/marketing-page-layout-container/footer-layout/footer-layout.interface';
import { getTopFanFooterLayoutData } from '@modules/shared/components/footer/footer.constants';
import { HeaderFooterStateService } from '@modules/shared/services/header-footer-state.service';
import { CommonService } from '@shared/services/common.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-footer',
  imports: [CommonModule, FooterLayoutComponent],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, OnDestroy {
  isFooterVisible = false;
  footerData: FooterLayoutData = getTopFanFooterLayoutData();
  footerHostStyle: Record<string, string> | null = null;

  private readonly destroy$ = new Subject<void>();

  constructor(
    public readonly cs: CommonService,
    private readonly authService: AuthService,
    private readonly headerFooterStateService: HeaderFooterStateService
  ) {}

  ngOnInit(): void {
    this.headerFooterStateService.footerStateSubject
      .pipe(takeUntil(this.destroy$))
      .subscribe((state) => {
        this.isFooterVisible =
          state.isFooterVisible && !this.authService.isWhiteLabelWebsite();
        this.footerData = getTopFanFooterLayoutData(
          this.cs.isBrowser && this.authService.isAuthenticated()
        );
        this.footerHostStyle = this.buildHostStyle(
          state.footerBackgroundColor,
          state.footerThemeColor
        );
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private buildHostStyle(
    backgroundColor: string | null,
    themeColor: string | null
  ): Record<string, string> | null {
    if (!backgroundColor) {
      return null;
    }
    const style: Record<string, string> = {
      '--configBgColor': backgroundColor
    };
    if (themeColor) {
      style['--configBgTextColor'] = themeColor;
      style['--configPostTextColor'] = themeColor;
    }
    return style;
  }
}
